<template>
  <v-container class="history-container">
    <v-row no-gutters class="history-title">
      {{ $t('device.list.item.history') }}
    </v-row>
    <v-row no-gutters class="history-wrapper">
      <v-col v-if="isFetched" :id="`device-history-list-${device.id}`">
        <v-row
          v-for="(log, index) in historyLogs"
          :id="`history-${device.id}-row-${index}`"
          :key="`history-log-${index}`"
          no-gutters
          class="history-log"
        >
          <v-col :id="`history-${device.id}-row-${index}-date`" class="col-md-3 history-text">{{ formatDate(log.timestamp) }}</v-col>
          <v-col :id="`history-${device.id}-row-${index}-operation`" class="col-md-9 history-value">
            <span>{{ $t(`device.history.${log.operation}`) }}</span>
            <span v-if="$i18n.locale === 'fr'">&nbsp;:&nbsp;</span>
            <span v-else>:&nbsp;</span>
            <span>{{ $t(`device.history.${log.subCategory}`) }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div>
              <span :id="`history-${device.id}-newinformation`" class="new-information" @click="viewTheHistory()">
                {{ $t('common.new_information') }}
              </span>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col v-else-if="isLoading">
        <v-row
          v-for="i in 10"
          :key="`loading-${i}`"
          no-gutters
        >
          <Loaders type="label" />
        </v-row>
      </v-col>
      <v-col v-else-if="isError">
        <v-row>
          <div>{{ $t('common.huge_error') }}</div>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import { IDevicesListState, store as deviceStore } from '@/store/modules/devices/types';
import Loaders from '@/components/common/Loaders/Loaders.vue';
import { store } from '@/store/modules/permissions/types';
import { V2Device } from 'ctp-search-device';

@Component({
  components: {
    Loaders
  }
})
export default class HistoryBloc extends Vue {
  @Prop()
  private device: V2Device;

  @store.Getter
  private getCurrentUserIsAbleTo: (readOrWrite: string, featureName: string) => boolean;

  @deviceStore.Getter
  private getDevicesHistory: any[];

  @deviceStore.Getter
  private getDevicesListState!: IDevicesListState;

  private get isLoading() {
    return this.getDevicesListState?.loading?.devicesHistory[this.device.shortDeviceId!];
  }

  private get isFetched() {
    return this.getDevicesListState?.fetched?.devicesHistory[this.device.shortDeviceId!];
  }

  private get isError() {
    return this.getDevicesListState?.error?.devicesHistory[this.device.shortDeviceId!];
  }

  private get historyLogs() {
    return this.getDevicesHistory?.find(log => log.deviceId === this.device.shortDeviceId)?.history;
  }

  private getCurrentUserIsAbleToRead(featureName: string) {
    return featureName
      ? this.getCurrentUserIsAbleTo('read', featureName)
          || this.getCurrentUserIsAbleTo('write', featureName)
      : false;
  }

  private async viewTheHistory() {
    this.$router.push({
      name: 'history',
      params: {
        deviceId: this.device.shortDeviceId || ''
      }
    });
  }

  private formatDate(timestamp: number) {
    return moment(timestamp * 1000).format('DD/MM/YYYY');
  }
}
</script>
<style lang="scss" scoped>
@import './styles/history-bloc.scss';
</style>
